import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable()
export class OnboardingDetailsService {

  constructor(private http: HttpClient) { }
  api_url = environment.SERVER_URL + 'icrweb/home/'
  getFormMasters(obj, params) {
    return this.http.post(this.api_url + "DynamicTemplate/FormPlotMasters", obj, {
      params: params
    });
  }
  getResumeDetails(params) {
    return this.http.get(environment.SERVER_URL + 'Onboarding/Details', {
      params: params
    });
  }
  getOfferDetails(param_obj) {
    return this.http.get(environment.SERVER_URL + 'Onboarding/Details', { params: param_obj });
  }
  getOnBoardingDetails(params) {
    return this.http.get(this.api_url + "OnBoarding/Details", {
      params: params
    })
    // return this.HttpService.get('assets/sample/data.json')
  }

  updateVerificationFieldStatus(obj, params) {
    return this.http.post(environment.SERVER_URL + 'OnBoarding/updateVerificationFieldStatus', obj, { params: params });
  }



  getOnboardingDetails(obj = {}) {
    obj['sellerShortCode'] = environment.SHORTCODE;
    return this.http.post(this.api_url + 'get_myjourney_onboarding_form_details', obj)
  }

  submitOnboardingDetails(obj = {}) {
    obj['sellerShortCode'] = environment.SHORTCODE;
    return this.http.post(this.api_url + 'submit_myjourney_onboarding_form_details', obj)
  }


  getAppointmentAcceptance(obj = {}) {
    obj['sellerShortCode'] = environment.SHORTCODE;
    return this.http.post(this.api_url + 'get_myjourney_appointment_acceptance_details', obj)
  }

  submitAppointmentAcceptance(obj = {}) {
    obj['sellerShortCode'] = environment.SHORTCODE;
    return this.http.post(this.api_url + 'submit_myjourney_appointment_acceptance', obj)
  }
}
